module.exports = __webpack_public_path__ + "static/media/b06.7e795612.jpg";